import React, { Component } from 'react'
import createBrowserHistory from 'history/createBrowserHistory'
import createMemoryHistory from 'history/createMemoryHistory'
import { Switch } from 'react-router'
import { connectRouter, ConnectedRouter, routerMiddleware } from 'connected-react-router'
import {
    CodeAccess,
    Tour,
    PreSeason,
    PreRace,
    Race,
    PostRace,
    PostSeason,
    Loading,
    App,
    Onboarding,
    Intro,
    Presets,
    Signin,
    McHome,
    NewGameStep1,
    NewGameStep2,
    NewGameStep3,
    McGame,
    McGameList,
    SuperAdminSignin,
    SuperAdminHome,
    SuperAdminConfigFile,
    PageNotFound,
    Signout
} from 'pages'
import Config from 'config'
import Route from './Route'

const history = Config.router.useMemory ? createMemoryHistory() : createBrowserHistory()

export const routeMiddleware = routerMiddleware(history)

export const connectedRouter = connectRouter(history)

class Router extends Component {
    render() {
        return (
            <ConnectedRouter history={history}>
                <Switch>
                    <Route exact path="/test1234" component={App} />

                    {/* Player */}
                    <Route user guest exact path="/" component={CodeAccess} />
                    <Route user guest exact path="/new-game" component={CodeAccess} />
                    <Route user secured exact path="/tour" component={Tour} />
                    <Route user secured exact path="/pre-season" component={PreSeason} />
                    <Route user secured exact path="/pre-race" component={PreRace} />
                    <Route user secured exact path="/race" component={Race} />
                    <Route user secured exact path="/post-race" component={PostRace} />
                    <Route user secured exact path="/post-season" component={PostSeason} />
                    <Route user secured exact path="/loading" component={Loading} />
                    <Route user secured exact path="/intro" component={Intro} />
                    <Route user secured exact path="/onboarding" component={Onboarding} />
                    <Route user secured exact path="/presets" component={Presets} />

                    {/* Master of ceremonies */}
                    <Route mc guest exact path="/mc/signin" component={Signin} />
                    <Route mc secured exact path="/mc" component={McHome} />
                    <Route mc secured exact path="/mc/new-game/step1" component={NewGameStep1} />
                    <Route mc secured exact path="/mc/new-game/step2" component={NewGameStep2} />
                    <Route mc secured exact path="/mc/new-game/step3" component={NewGameStep3} />
                    <Route mc secured exact path="/mc/game" component={McGame} />
                    <Route mc secured exact path="/mc/games" component={McGameList} />

                    {/* SuperAdmin */}
                    <Route admin guest exact path="/admin/signin" component={SuperAdminSignin} />
                    <Route admin secured exact path="/admin" component={SuperAdminHome} />
                    <Route admin secured exact path="/admin/config" component={SuperAdminConfigFile} />

                    <Route exact path="/signout" component={Signout} />
                    <Route component={PageNotFound} />
                </Switch>
            </ConnectedRouter>
        )
    }
}

export default Router



// WEBPACK FOOTER //
// src/router/index.js